export const routes = {
  root: "/",
  about: "/about-us",
  overview: "/about-us/overview",
  leadership: "/about-us/leadership",
  history: "/about-us/history",
  contact: "/contact-us",
  Blogs: "/blogs",
  update: "/updates",
  productDetails: "/our-products/:nameId",
  specificblog: "/blogs/:id",
  career: "/career",
  specificejob : "/career/job/:id",
  ourProducts: "/our-products",
  researchInnovation: "/research-innovation",
};
